import { enqueueSnackbar } from 'notistack';
import useSWRMutation from 'swr/mutation';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { axFetch } from '/@/store/session/actions';

export const useResendVerificationEmail = () => {
    return useSWRMutation(settings.urls.users.resendVerificationEmail, axFetch.post, {
        onSuccess: () => {
            enqueueSnackbar(_('Email de verificación enviado'), { variant: 'success' });
        },
        onError: () => {
            enqueueSnackbar(_('Error al enviar email de verificación'), { variant: 'error' });
        },
    });
};

export const useInviteUser = () => {
    const apiUrl = new URL(`${(settings as any).urls.apiDomain}/core/v1/users/invite/`, window.location.origin);
    return useSWRMutation(
        apiUrl.toString(),
        (url: string, { arg }: { arg: { email: string } }) => axFetch.post(url, { email: arg.email }),
        {
            onSuccess: () => {
                enqueueSnackbar(_('Invitación enviada con éxito'), { variant: 'success' });
            },
            onError: () => {
                enqueueSnackbar(_('Error al enviar la invitación'), { variant: 'error' });
            },
        }
    );
};
